import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { environment } from '../../environments/environment';

import { firstValueFrom, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class EpsService {
  private http = inject(HttpClient);

  url = environment.url.bffV3;
  private runsOfStation = {};
  private epsData = {};

  public epsRunsExists(stationId: number) {
    return this.runsOfStation.hasOwnProperty(stationId);
  }
  public getRunsOfStation(
    model: string,
    stationId: number,
    doReload = false
  ): Promise<Array<string>> {
    return new Promise<Array<string>>((resolve, reject) => {
      if (!doReload && this.runsOfStation.hasOwnProperty(stationId)) {
        resolve(this.runsOfStation[stationId]);
      } else {
        this.getRunsOfStationFromBff(model, stationId).subscribe(data => {
          this.runsOfStation[stationId] = data;
          resolve(data);
        });
      }
    });
  }

  getRunsOfStationFromBff(model: string, stationId: number): Observable<any> {
    const fullUrl = this.url + '/eps/' + model + '/' + stationId + '/runs';
    return this.http.get<Array<string>>(fullUrl).pipe(
      map(data => {
        return data;
      })
    );
  }

  public getEpsData(
    model: string,
    stationId: number,
    parameter: string,
    modelRun: string,
    doReload = false
  ): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      if (
        !doReload &&
        this.epsData.hasOwnProperty(model) &&
        this.epsData.hasOwnProperty(stationId) &&
        this.epsData[stationId].hasOwnProperty(parameter) &&
        this.epsData[stationId][parameter].hasOwnProperty(modelRun)
      ) {
        resolve(this.epsData[stationId][parameter][modelRun]);
      } else {
        this.getEpsDataFromBff(model, stationId, parameter, modelRun).subscribe(
          data => {
            if (!this.epsData.hasOwnProperty(model)) {
              this.epsData[model] = {};
            }
            if (!this.epsData[model].hasOwnProperty(stationId)) {
              this.epsData[model][stationId] = {};
            }
            if (!this.epsData[model][stationId].hasOwnProperty(parameter)) {
              this.epsData[model][stationId][parameter] = {};
            }
            this.epsData[model][stationId][parameter][modelRun] = data;
            resolve(data);
          }
        );
      }
    });
  }

  getEpsDataFromBff(
    model: string,
    stationId: number,
    parameter: string,
    modelRun: string
  ): Observable<any> {
    const levels = {
      ttt: '002',
      rrr: '000',
      fff: '100',
      power: '100',
    };
    const units = {
      ttt: 'C',
      rrr: 'mm',
      fff: 'mps',
      power: 'MWh',
    };
    const bodyJson = {
      model,
      parameter,
      level: levels[parameter],
      unit: units[parameter],
    };
    const body = JSON.stringify(bodyJson);
    const fullUrl = this.url + '/eps/' + stationId + '/' + modelRun;
    return this.http
      .post<Array<any>>(fullUrl, body, {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
        }),
      })
      .pipe(
        map(data => {
          if (data.length > 0) {
            if (
              data[0].hasOwnProperty('timeseries') &&
              data[0].timeseries.hasOwnProperty('timeItems')
            ) {
              return data[0].timeseries.timeItems;
              /*return this.calculateEpsData(
                parameter,
                data[0].timeseries.timeItems
              );

               */
            }
          }
          return [];
        })
      );
  }

  calculateEpsData(parameter: string, rawData: any[]): any[] {
    if (parameter != 'rrr') {
      return rawData;
    }
    const calculatedData = [];
    let latest = {
      avg: 0.0,
      min: 0.0,
      max: 0.0,
      10: 0.0,
      50: 0.0,
      90: 0.0,
    };
    for (const dataset of rawData) {
      const newDataset = {
        dtg: dataset.dtg,
        weatherparameters: [{}],
        original: dataset.weatherparameters[0],
      };
      for (const run of ['avg', 'min', 'max', '10', '50', '90']) {
        newDataset.weatherparameters[0][run] = Math.max(
          dataset.weatherparameters[0][run] - latest[run],
          0.0
        );

        latest[run] = dataset.weatherparameters[0][run];
      }
      calculatedData.push(newDataset);
    }
    return calculatedData;
  }

  async debugBackendResponse(): Promise<void> {
    const time = '2026-03-31T06:00:00Z';
    const stationId = 105530;
    const body = {
      model: 'ecm',
      parameter: 'ttt',
      level: '002',
      unit: 'C',
    };

    const epsUrl = `${this.url}/eps/${stationId}/${time}`;
    const modelUrl = `${this.url}/model/${stationId}/${time}`;

    console.log('EPS debug request body:', body);

    try {
      const epsResponse = await firstValueFrom(
        this.http.post(epsUrl, body, {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
          }),
        })
      );
      console.log('EPS response:', epsResponse);
    } catch (error) {
      console.error('EPS request failed:', error);
    }

    try {
      const modelResponse = await firstValueFrom(
        this.http.post(modelUrl, body, {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
          }),
        })
      );
      console.log('MODEL response:', modelResponse);
    } catch (error) {
      console.error('MODEL request failed:', error);
    }
  }
}
